import { render, staticRenderFns } from "./dialog_contact.vue?vue&type=template&id=05fa8908&scoped=true&"
import script from "./dialog_contact.vue?vue&type=script&lang=js&"
export * from "./dialog_contact.vue?vue&type=script&lang=js&"
import style0 from "./dialog_contact.vue?vue&type=style&index=0&id=05fa8908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fa8908",
  null
  
)

export default component.exports